import { Link } from 'react-router'
import computerIcon from '/img/computer.svg'
import contractEditIcon from '/img/contract_edit.svg'
import developerGuideIcon from '/img/developer_guide.svg'
import errorIcon from '/img/error.svg'
import { Button } from '#app/components/ui/button'
import { Card, CardContent } from '#app/components/ui/card'
import { Icon } from '#app/components/ui/icon'
export default function TenantScreeningRoute() {
	return (
		<div className="w-full min-h-screen overflow-hidden">
			{/* Hero Section */}
			<section className="sm:px-6 px-[15px] md:px-[100px] py-16 lg:py-24">
				<div className="mx-auto">
					<div className="text-center mb-16">
						<h1 className="text-3xl md:text-5xl lg:text-6xl font-normal font-['Futura_Hv_BT'] text-neutral-800 mb-12">
							Lease Generator
						</h1>
						<h2 className="text-2xl md:text-3xl font-normal font-['Futura_Md_BT'] text-gray-900 mb-6 text-left mx-auto">
							Smarter Leases, Seamlessly Created
						</h2>
						<p className="text-lg md:text-xl font-normal font-['Futura_Bk_BT'] text-gray-700 text-left mx-auto leading-relaxed">
							Forget hours spent drafting paperwork. With TrueTenant, our
							AI-powered Lease Generator creates a complete lease for you in
							minutes — accurate, compliant, and ready to sign.
						</p>
					</div>
					<hr className="border-[#CDCDCD] mt-6" />
				</div>
			</section>

			{/* Why Landlords Trust Our Formula Section */}
			<section className="px-4 sm:px-6 lg:px-[100px]  py-8">
				<div className="mx-auto">
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
						{/* Left: Visual Graphic */}
						<div className="relative">
							<h2 className="text-2xl md:text-3xl lg:text-4xl font-normal font-['Futura_Md_BT'] text-gray-900 mb-8">
								Why Landlords Love It
							</h2>
							<img src={'/img/analytics-image2.png'} alt="Tenant Screening" />
						</div>

						{/* Right: Feature List */}
						<div className="space-y-8">
							<div className="justify-between flex flex-col gap-10">
								{/* Proven For 20+ Years */}
								<Card className="bg-transparent border border-[#AEAEAE] shadow-none rounded-xl">
									<CardContent className="p-6">
										<div className="flex items-start gap-4">
											<div className="w-2 h-2 bg-gray-600 rounded-full mt-3 flex-shrink-0" />
											<div>
												<h3 className="text-xl  font-['Futura_Md_BT'] text-gray-900 mb-2">
													AI-Powered Drafting
												</h3>
												<p className="text-gray-700 font-['Futura_Bk_BT']">
													Instantly generate a professional lease based on your
													property details.
												</p>
											</div>
										</div>
									</CardContent>
								</Card>

								{/* Comprehensive Insights */}
								<Card className="bg-transparent border border-[#AEAEAE] shadow-none rounded-xl">
									<CardContent className="p-6">
										<div className="flex items-start gap-4">
											<div className="w-2 h-2 bg-gray-600 rounded-full mt-3 flex-shrink-0" />
											<div>
												<h3 className="text-xl  font-['Futura_Md_BT'] text-gray-900 mb-2">
													Customizable Terms
												</h3>
												<p className="text-gray-700 font-['Futura_Bk_BT']">
													Upload your own conditions or add specific clauses
													tailored to your needs.
												</p>
											</div>
										</div>
									</CardContent>
								</Card>

								{/* Ongoing Soft Checks */}
								<Card className="bg-transparent border border-[#AEAEAE] shadow-none rounded-xl">
									<CardContent className="p-6">
										<div className="flex items-start gap-4">
											<div className="w-2 h-2 bg-gray-600 rounded-full mt-3 flex-shrink-0" />
											<div>
												<h3 className="text-xl  font-['Futura_Md_BT'] text-gray-900 mb-2">
													Seamless Process
												</h3>
												<p className="text-gray-700 font-['Futura_Bk_BT']">
													Both you and your tenant review and sign digitally,
													making the entire experience quick, simple, and
													stress-free.
												</p>
											</div>
										</div>
									</CardContent>
								</Card>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* The TrueTenant Advantage Section */}
			<section className="px-4 sm:px-6 lg:px-[100px] py-16 lg:py-24">
				<div className="mx-auto">
					<div className="text-center mb-16">
						<h2 className="text-2xl md:text-3xl lg:text-4xl font-normal font-['Futura_Md_BT'] text-gray-900 mb-8">
							The TrueTenant Advantage
						</h2>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
						{/* Card 1: Continuous Protection */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-8">
								<div className="flex items-center justify-center mx-auto mb-6">
									<img
										src={developerGuideIcon}
										alt="Encrypted"
										className="w-8 h-8 text-white"
									/>
								</div>
								<h3 className="text-xl  font-['Futura_Bk_BT'] text-gray-900 mb-4">
									Faster leasing with AI-generated contracts
								</h3>
							</CardContent>
						</Card>

						{/* Card 2: Early Warnings */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-8">
								<div className="flex items-center justify-center mx-auto mb-6">
									<img
										src={contractEditIcon}
										alt="Bar Chart"
										className="w-8 h-8 text-white"
									/>
								</div>
								<h3 className="text-xl  font-['Futura_Bk_BT'] text-gray-900 mb-4">
									Flexibility to include your own terms and conditions
								</h3>
							</CardContent>
						</Card>

						{/* Card 3: Proven Results */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-8">
								<div className="flex items-center justify-center mx-auto mb-6">
									<img
										src={computerIcon}
										alt="Emergency Home"
										className="w-8 h-8 text-white"
									/>
								</div>
								<h3 className="text-xl  font-['Futura_Bk_BT'] text-gray-900 mb-4">
									Streamlined digital signing for both
								</h3>
							</CardContent>
						</Card>

						{/* Card 4: Smart Decisions */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-8">
								<div className="flex items-center justify-center mx-auto mb-6">
									<img
										src={errorIcon}
										alt="Published With Changes"
										className="w-8 h-8 text-white"
									/>
								</div>
								<h3 className="text-xl  font-['Futura_Bk_BT'] text-gray-900 mb-4">
									Reduce errors and delays with smart automation
								</h3>
							</CardContent>
						</Card>
					</div>

					<div className="mx-auto text-center mt-20">
						<Button asChild className="rounded-full">
							<Link to="/signup" className="flex items-center gap-2">
								Start Now
								<Icon name="arrow-right" className="w-5 h-5" />
							</Link>
						</Button>
					</div>
				</div>
			</section>
		</div>
	)
}
